export default __webpack_public_path__ + "static/media/Logo.43fd3d70.svg";